import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LinksService } from '@app/core/links.service';
import { StorageService } from '@app/core/storage.service';
import { OmguiButtonSize, OmguiButtonType, OmguiButtonVariant } from '@omgui/omgui-button/omgui-button.component';

@Component({
  selector: 'password-reset-email-sent',
  templateUrl: './password-reset-email-sent.component.html',
  styleUrls: ['./password-reset-email-sent.component.scss'],
})
export class PasswordResetEmailSentComponent implements OnInit {
  email = '';
  readonly OmguiButtonVariant = OmguiButtonVariant;
  readonly OmguiButtonSize = OmguiButtonSize;
  readonly OmguiButtonType = OmguiButtonType;

  constructor(readonly links: LinksService, private router: Router, private storageService: StorageService) {}

  ngOnInit(): void {
    this.email = this.storageService.getItem('forgot_password_email') || '';
  }

  onBackToLogin(): void {
    // Clear stored email and related data when going back to login
    this.storageService.removeItem('forgot_password_email');
    this.storageService.removeItem('forgot_password_use_preferred_email');
    this.storageService.removeItem('verificationToken');
    this.router.navigate(['/login']);
  }
}
